import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root',
})
export class MetricsService {
  recordings;
  errorGetRecords: boolean;
  constructor(public afs: AngularFirestore) {}

  getTotalRecording() {
    return this.afs.collection('accentsdata').valueChanges();
  }

  getTodaysRecord() {
    return this.getTotalRecording();
  }
}
